import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag-list-atom',
  templateUrl: './tag-list-atom.component.html',
  standalone: false,
})
export class TagListAtomComponent {
  @Input() tags!: any[];
}
